import axios from "axios";
import params from "../../../config/params";

require("dotenv").config();

let BASE_URL = params.PROD.CLIENT.RETURN_SOLICITATION.SPECIFIC_FIELDS.BASE_URL;

if (process.env.NODE_ENV === "development") {
  BASE_URL = params.DEV.CLIENT.RETURN_SOLICITATION.SPECIFIC_FIELDS.BASE_URL;
}
if (process.env.NODE_ENV === "qa") {
  BASE_URL = params.QA.CLIENT.RETURN_SOLICITATION.SPECIFIC_FIELDS.BASE_URL;
}

const getSpecificFields = (subFamily, causeCode) => {
  let idSubFamily = parseSubfamily(subFamily);
  return axios.get(
    `${BASE_URL}/return-request/specific-fields?subFamily=${idSubFamily}&causeCode=${causeCode}`
  );
};

const parseSubfamily = subFamily => {
  if (subFamily == "Compressores Herméticos Embraco") {
    return 2;
  }
  return 76;
};

const parseSpecificFields = specificFields => {
  let fields = {
    fieldCashierTag: specificFields.field_cashier_tag,
    fieldExchangeVoucher: specificFields.field_exchange_voucher,
    fieldInvoicePhoto: specificFields.field_invoice_photo,
    fieldMaterialPhoto: specificFields.field_material_photo,
    fieldPaCode: specificFields.field_pa_code,
    fieldPaEngineeringVersion: specificFields.field_pa_engineering_version,
    fieldPaSerieNumber: specificFields.field_pa_serie_number,
    fieldSerieNumber: specificFields.field_serie_number,
    fieldWarrantyPhoto: specificFields.field_warranty_photo
  };
  return fields;
};

export default {
  getSpecificFields,
  parseSpecificFields
};
